import { render, staticRenderFns } from "./XtendGuideContent.vue?vue&type=template&id=e39c07ba&scoped=true&"
import script from "./XtendGuideContent.vue?vue&type=script&lang=js&"
export * from "./XtendGuideContent.vue?vue&type=script&lang=js&"
import style0 from "./XtendGuideContent.vue?vue&type=style&index=0&id=e39c07ba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e39c07ba",
  null
  
)

export default component.exports